/** Base URL del backend (CRA inyecta REACT_APP_* en build). */
export const API_URL = "https://api.centralitamunicipal.com";
